/* eslint-disable react-refresh/only-export-components -- the provider and the hook it serves belong together */
// CUSTOMER ADAPTER (not vendored). The Control Board pages read the signed-in organization from `useAuth()`; in the
// customer build that session is Rithmo's own sign-in (context/AuthContext, context/OrgContext), passed in once by
// CustomerApp through CustomerSessionProvider. A 401 from the Control Board API signs the person out the same way.
import { createContext, useContext, useEffect, useRef, type ReactNode } from 'react'
import { setUnauthorizedHandler } from '../api/http'

export interface SessionUser { email?: string | null; name?: string | null }
export interface Workspace { id: string; name: string }

interface CustomerSession {
  user: SessionUser | null
  workspace: Workspace | null
  signOut: () => void | Promise<void>
}

const SessionContext = createContext<CustomerSession>({ user: null, workspace: null, signOut: () => {} })

export function CustomerSessionProvider({ value, children }: { value: CustomerSession; children: ReactNode }) {
  const signOut = useRef(value.signOut)
  useEffect(() => { signOut.current = value.signOut })
  useEffect(() => {
    setUnauthorizedHandler(() => { void signOut.current() })
    return () => setUnauthorizedHandler(null)
  }, [])
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>
}

/** The Control Board's useAuth, over Rithmo's session: only ever rendered signed in (the customer routes guard it). */
export function useAuth() {
  return { status: 'signed_in' as const, ...useContext(SessionContext) }
}
